import React from "react"

import { addServerErrors } from "@/components/forms/common/FormBase"
import { MachineTypeFormData, SuperAdminInsertMachineTypeForm } from "@/components/forms/machinetypes/MachineType"
import { CurrentSession } from "@/services/repository/session"
import { Services } from "@/services/services"
import { useForm } from "react-hook-form"
import { MachineType } from "@/services/model/machine"

export const InsertMachineTypePopup = ({ services, session, onClose, onCreate }: {
  services: Services,
  session: CurrentSession,
  onClose: () => void
  onCreate: (data: MachineType) => void
}) => {
  const form = useForm<MachineTypeFormData>()

  const handle = (data: MachineTypeFormData): Promise<void> => {
    if (form === undefined) {
      return Promise.reject()
    }
    delete data.id
    return services.session.fetchWithToken(`/api/communal/machine_types/new`, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(async (r) => {
      if (r.status !== 200) {
        const errors = await r.json()
        addServerErrors(form, session.translates, errors)
        return
      }
      const response = await r.json()
      form.reset()
      onClose()
      onCreate({
        id: response.id,
        ...data
      })
    })
  }

  return <SuperAdminInsertMachineTypeForm
    onSubmit={handle}
    services={services}
    form={form}
    translates={session.translates}
    formName='machinetype'
    readOnly={false}
  />
}